"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "38", height: "38", viewBox: "0 0 38 38", className: "Icon toolbar-caption-on", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement(
            "g",
            { transform: "translate(1 1)", fill: "none", fillRule: "evenodd" },
            _react2.default.createElement("rect", { stroke: "#000", width: "36", height: "36", rx: "3", strokeWidth: "2" }),
            _react2.default.createElement("path", { fill: "#4C4C4C", d: "M5 24h26v2H5zM5 28h23v2H5z" }),
            _react2.default.createElement("path", { fill: "#BBB", d: "M1 19h34v1H1z" })
        )
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/large/jsx/toolbar-caption-on.js
// module id = 1834
// module chunks = 0